import { useEffect, useState } from 'react';
import RightSidebar from './components/right-side-bar/RightSidebar';
import QuickActions from './components/quick-actions/QuickActions';
import EngagementScore from './components/engagement-score/EngagementScore';
import FeatureGate from 'components/common/FeatureGate';
import { FEATURE } from 'constant/features';
import InitialDocuments from './components/BACKOFFICEFLOW/CLIENTVIEW/components/ClientProfile/components/InitialDocuments/InitialDocuments';
import ClientFlowInitialDocuments from './components/BACKOFFICEFLOW/CLIENTVIEW/components/ClientProfile/components/InitialDocuments/ClientFlowInitialDocuments';
import { Outlet, useMatch, useResolvedPath } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useWindowSize } from 'hooks/useWindowSize';
import QuickActionsButtonForMobile from './components/quick-actions/QuickActionsButtonForMobile';
import MenuForMobileDropdowns from './components/right-side-bar/MenuForMobileDropdowns';
import * as S from './Dashboard.styled';
import { useAuth } from 'contexts/ProtectedRoute';
import ROLE from '../../assets/userRoles.json';
import OrganizationQuickAction from '../v2/Dashboards-B2B/components/quickActions/organizationQuickAction';
import { DashboardViewProvider } from './components/BACKOFFICEFLOW/MYCLIENTS/components/dashboard/DashboardViewContext';

export default function Dashboard() {
    const [clientView, setClientView] = useState<boolean>(false);
    const [clientFlow, setClientFlow] = useState<boolean>(false);
    const [onboarding, setOnboarding] = useState<boolean>(false);
    const [organizationRoute, setOrganizationRoute] = useState<boolean>(false);
    const location = useLocation();
    const [width, height] = useWindowSize();
    const [mobile, setMobile] = useState(false);

    useEffect(() => {
        if (width >= 769) {
            setMobile(false);
        }
        if (width < 769) {
            setMobile(true);
        }
    }, [width, height]);

    useEffect(() => {
        if (location.pathname.includes('client-profile')) {
            setClientView(true);
            setClientFlow(false);
            setOnboarding(false);
            setOrganizationRoute(false);
        } else if (location.pathname.includes('visa-process')) {
            setClientFlow(true);
            setClientView(false);
            setOnboarding(false);
            setOrganizationRoute(false);
        } else if (location.pathname.includes('sales-onboarding')) {
            setOnboarding(true);
            setClientView(false);
            setClientFlow(false);
            setOrganizationRoute(false);
        } else if (location.pathname.includes('organization')) {
            setOrganizationRoute(true);
            setClientView(false);
            setClientFlow(false);
            setOnboarding(false);
        } else {
            setClientView(false);
            setClientFlow(false);
            setOnboarding(false);
            setOrganizationRoute(false);
        }
    }, [location.pathname]);

    const { role } = useAuth();
    const [backOfficeFlow, setbackOfficeFlow] = useState<boolean>(false);
    const resolvedDashboard = useResolvedPath('/dashboard');
    const matchDashboard = useMatch({ path: resolvedDashboard.pathname, end: true });
    const isDashboardPage = matchDashboard ? true : false;
    const isSalesPerson = role === ROLE.sales;

    useEffect(() => {
        if (
            isDashboardPage &&
            [
                ROLE.admin,
                ROLE.sales,
                ROLE.consultant,
                ROLE.backofficeAdmin,
                ROLE.backofficeConsultant,
                ROLE.superAdmin,
                ROLE.superSuperAdmin,
            ].includes(role)
        ) {
            setbackOfficeFlow(true);
        } else {
            setbackOfficeFlow(false);
        }
    }, [isDashboardPage, location.pathname, role]);

    const detailView = clientView || clientFlow || organizationRoute;

    return (
        <DashboardViewProvider>
            <S.MainLayout mobile={mobile}>
                <S.Page mobile={mobile}>
                    <S.MainContainer reducedWidth={detailView} mobile={mobile}>
                        <Outlet />
                    </S.MainContainer>

                    <S.RightSection
                        increasedWidth={detailView}
                        mobile={mobile}
                        controlMargin={organizationRoute ? false : backOfficeFlow}
                    >
                        {organizationRoute ? (
                            mobile ? null : (
                                <OrganizationQuickAction />
                            )
                        ) : (
                            <S.CardStack>
                                <QuickActions clientView={clientView} clientFlow={clientFlow} />
                                {clientView && (
                                    <FeatureGate feature={FEATURE.CLIENT_ENGAGEMENT}>
                                        <EngagementScore />
                                    </FeatureGate>
                                )}
                                {clientView && <InitialDocuments />}
                                {clientFlow && <ClientFlowInitialDocuments />}
                            </S.CardStack>
                        )}

                        <RightSidebar
                            clientFlow={clientFlow}
                            onboarding={onboarding}
                            mobile={mobile}
                        />
                    </S.RightSection>

                    <S.Footer mobile={mobile}>
                        {((clientView && !isSalesPerson) || clientFlow || onboarding) && (
                            <MenuForMobileDropdowns
                                mobile={mobile}
                                clientView={clientView}
                                clientFlow={clientFlow}
                                onboarding={onboarding}
                            />
                        )}

                        {organizationRoute ? (
                            mobile ? (
                                <OrganizationQuickAction variant="footer" />
                            ) : null
                        ) : (
                            <QuickActionsButtonForMobile
                                clientView={clientView}
                                clientFlow={clientFlow}
                            />
                        )}
                    </S.Footer>
                </S.Page>
            </S.MainLayout>
        </DashboardViewProvider>
    );
}
